import React from 'react';
import { MessageSquareOff, EyeOff, MicOff } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gaming-card relative border-y border-gaming-purple/10" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        {/* The Hook */}
        <div className="relative p-8 md:p-12 bg-gaming-bg border border-gaming-purple/20 rounded-lg mb-16 box-glow-purple" data-id="element-176">
          <div className="absolute -top-5 left-8 bg-gaming-card px-4 py-1 border border-gaming-purple/30 rounded text-gaming-purple-light font-orbitron text-sm tracking-widest" data-id="element-177">
            LA REALIDAD
          </div>
          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed italic" data-id="element-178">
            "Estás ahí, con los audífonos puestos y el juego corriendo, pero el
            contador de espectadores marca{' '}
            <span className="text-red-500 font-bold not-italic text-glow-purple" data-id="element-179">
              0
            </span>
            . Has pasado cuatro horas dándolo todo y nadie ha escrito en el
            chat."
          </p>
        </div>

        {/* The Problem Details */}
        <div className="space-y-8" data-id="element-180">
          <h2 className="font-orbitron text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-181">
            El silencio en tu chat es el ruido más{' '}
            <span className="text-gaming-cyan text-glow-cyan" data-id="element-182">frustrante</span>{' '}
            del mundo.
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-183">
            <div className="bg-gaming-bg p-6 rounded-lg border border-gray-800 hover:border-gaming-purple/50 transition-colors" data-id="element-184">
              <EyeOff className="w-10 h-10 text-gaming-purple-light mb-4" data-id="element-185" />
              <h3 className="text-white font-orbitron font-bold mb-2" data-id="element-186">
                El Streamer Invisible
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-187">
                Sientes que estás perdiendo el tiempo mientras ves a otros
                streamers con setups mediocres atrayendo a cientos de personas.
              </p>
            </div>

            <div className="bg-gaming-bg p-6 rounded-lg border border-gray-800 hover:border-gaming-purple/50 transition-colors" data-id="element-188">
              <MicOff className="w-10 h-10 text-gaming-purple-light mb-4" data-id="element-189" />
              <h3 className="text-white font-orbitron font-bold mb-2" data-id="element-190">
                La Trampa del Equipo
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-191">
                Crees que necesitas una cámara 4K, un micrófono de estudio y
                luces RGB. Te endeudas pensando que eso traerá a la audiencia.
              </p>
            </div>

            <div className="bg-gaming-bg p-6 rounded-lg border border-gray-800 hover:border-gaming-purple/50 transition-colors" data-id="element-192">
              <MessageSquareOff className="w-10 h-10 text-gaming-purple-light mb-4" data-id="element-193" />
              <h3 className="text-white font-orbitron font-bold mb-2" data-id="element-194">
                El Problema Real
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-195">
                Pero el problema no eres tú, ni tu equipo. Es que nadie te
                enseñó la verdadera arquitectura de la atención.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}